import { createSlice } from '@reduxjs/toolkit';
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AsyncThunkAction } from '../asyncThunk';
const initialState = {
    gaiConfig: []
}


export const getGaiConfig = AsyncThunkAction('gai/config', API_BASE_URL + ApiURLs.Config.Gai)

const gaiSlice = createSlice({
    name: 'gai',
    initialState: initialState,
    reducers: {     
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGaiConfig.pending, (state, action) => {
                // state.userInfo.status = RequestStatus.Pending;
            })
            .addCase(getGaiConfig.fulfilled, (state, action) => {
                window.slbConfig.gaiConfig = action?.payload?.data;
                state.gaiConfig = action?.payload?.data;
            }).addCase(getGaiConfig.rejected, (state, action) => {
                // state.userInfo.status = RequestStatus.Rejected
            })
    }
})

export default gaiSlice.reducer